import { ApiClient } from '@/services/api.service';
import { MyProfile, type Profile } from '@/types/profile';
import { jwtService } from '@/services/jwt.service';

class AuthApi {
    async getProfile() {
        const data = await ApiClient.get<Profile>(`/profile/`, {}).catch((error) => {
            const status = error.response ? error.response.status : null;

            // Пока проверка на 403 ошибку
            if (status === 403 && !error.response.data.is_banned) {
                alert('Внутренняя ошибка');
            } else {
                return error.response;
            }
        });

        return data;
    }

    async updatedProfile(updateUserDataDto: Partial<Profile>) {
        const data = await ApiClient.patch<any>(`/profile/`, {
            profile: updateUserDataDto,
        });
        return data;
    }

    async logout() {
        //await ApiClient.post('/auth/logout');
        jwtService.destroyToken();
    }

    async completeRegistration() {
        const data = await ApiClient.patch<any>(`/registration/complete/`, );
        return data;
    }

    async partiallyCompleteRegistration() {
        const data = await ApiClient.patch<{ profile: MyProfile }>(`/registration/skip/`, );
        return data;
    }
}

export const authApi = new AuthApi();
